export default {
    lang: {
        name: 'Group comments'
    }
}